module.exports = __webpack_public_path__ + "static/property-hideaways-macromenu-9b6974443b6d1790d50fee58600f5919.jpg";